/* Diwali Festive UI — small custom elements, safe to load multiple times */
(() => {
  if (window.__dwLoaded) return;
  window.__dwLoaded = true;

  // Hero slider
  class DwSlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.dw-slide')];
      this.dots = [...this.querySelectorAll('.dw-dot')];
      this.i = 0;
      this.dots.forEach((d, n) => d.addEventListener('click', () => { this.go(n); this.start(); }));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      let x0 = null;
      this.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { this.go(this.i + (dx < 0 ? 1 : -1)); this.start(); }
        x0 = null;
      });
      this.go(0);
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    go(n) {
      if (!this.slides.length) return;
      this.i = (n + this.slides.length) % this.slides.length;
      this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.i));
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.i));
    }
    start() {
      this.stop();
      const ms = parseInt(this.dataset.autoplay || '0', 10) * 1000;
      if (ms > 0 && this.slides.length > 1) this.t = setInterval(() => this.go(this.i + 1), ms);
    }
    stop() { clearInterval(this.t); }
  }

  // "in N days" countdown on festival tiles
  class DwDays extends HTMLElement {
    connectedCallback() {
      const today = new Date(); today.setHours(0, 0, 0, 0);
      this.querySelectorAll('[data-date]').forEach(tile => {
        const pill = tile.querySelector('.dw-day__pill');
        const parts = (tile.dataset.date || '').split('-').map(Number);
        if (parts.length !== 3 || !pill) return;
        const d = new Date(parts[0], parts[1] - 1, parts[2]);
        const diff = Math.round((d - today) / 86400000);
        tile.classList.remove('is-today', 'is-past');
        if (diff > 1) pill.textContent = `in ${diff} days`;
        else if (diff === 1) pill.textContent = 'Tomorrow';
        else if (diff === 0) { pill.textContent = 'Today'; tile.classList.add('is-today'); }
        else { pill.textContent = 'Celebrated'; tile.classList.add('is-past'); }
      });
    }
  }

  // Shop-by-price tabs
  class DwTabs extends HTMLElement {
    connectedCallback() {
      const pills = [...this.querySelectorAll('.dw-pill')];
      const panes = [...this.querySelectorAll('.dw-pane')];
      pills.forEach((p, n) => p.addEventListener('click', () => {
        pills.forEach((q, k) => { q.classList.toggle('is-active', k === n); q.setAttribute('aria-selected', k === n); });
        panes.forEach((q, k) => { q.hidden = k !== n; });
      }));
    }
  }

  // Horizontal carousel arrows
  class DwScroller extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.dw-track');
      if (!track) return;
      const step = dir => {
        const card = track.firstElementChild;
        const w = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      };
      this.querySelector('[data-prev]')?.addEventListener('click', () => step(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => step(1));
    }
  }

  const def = (n, c) => { if (!customElements.get(n)) customElements.define(n, c); };
  def('dw-slider', DwSlider);
  def('dw-days', DwDays);
  def('dw-tabs', DwTabs);
  def('dw-scroller', DwScroller);
})();
